import React from 'react';
import Logo from "../../assets/img/taskde-Logo.png";

const Chatpage = () => {
    return (
        <React.Fragment>
            <div className='chatmain_page'>
                <div class="chatmain_sec">
                    <div class="chatmain_sub">
                        <div class="chatmain_contents">
                            <div class="chatmain_img">
                                <img className='chatmain_logo' src={Logo} alt='' />
                            </div>
                            <div className='chatmain_timer'>00:00:00</div>
                        </div>
                        <div class="chatmain_video">
                            <div class="chatmain_videosub">
                                <div class="chatmain_videosec video_sec">
                                    <video autoplay="" class="chatmain_video video_play" playsinline=""></video>
                                    <div class="chatmain_videomain">
                                        <div className='chatmain_theme'>a</div>
                                    </div>
                                    <div class="chatmain_username">
                                        <span class="chatmain_iconmain chatmain_icon"></span>
                                        <p class="chatmain_unmuteVideo">anjana</p>
                                    </div>
                                </div>
                                <div class="chatmain_side">
                                    <video autoplay="" class="chatmainside_video chatmain_videocall" playsinline=""></video>
                                    <div class="chatmain_contentpage">
                                        <div className='chatmainpage_title'>r</div>
                                    </div>
                                    <div class="chatmain_user">
                                        <span class="chatmain_usermute chatmain_usermuted"></span>
                                        <p class="chatmain_unmuteVideopage">resil</p>
                                        <span class="chatmain_you">(You)</span>
                                    </div>
                                </div>
                                <div class="chatmain_end"></div>
                            </div>

                        </div>
                        <div class="chatmain_callend">
                            <div class="chatmain_callend_sec">
                                <div class="chatmainpage_mic chatmainpage_micaudio"></div>
                                <div class="chatmainpage_endbtn"></div>
                            </div>
                            <div class="chatmain_leftside_icons">
                                <div class="chatmainpage_leftside"></div>
                                <div class="chatmainpage_usericon">
                                    <span class="chatmainpgae_number">2</span>
                                </div>
                            </div>
                        </div>
                        <div class="chatmain_roommembers" style={{ display: "none" }}>
                            <div class="chatmain_room_title">Room members<span class="chatmain_closebtn"></span>
                            </div>
                            {/* <div class="Z2PYS5vNVghY4m46zQQV">
                                <div class="hkGTFmd1GeMzMEf8vNW_">
                                    <div class="T89FjqHm_Mbbi9RhEqd7" data-id="resil">
                                        <div class="i8ct3MPKG0I8SA9qfu6m Dp9dbt0Fgqf3teHekKjV">
                                            <span style="color: rgb(31, 173, 64);">r</span>
                                            <p>resil</p>(You)
                                        </div>
                                        <div class="IwZOSgDXLFSgH8L1UBdn">
                                            <div class="nBWwl6VwTRoZfXN7bSSA">Pin</div>
                                        </div>
                                    </div>
                                    <div class="T89FjqHm_Mbbi9RhEqd7" data-id="anjana">
                                        <div class="i8ct3MPKG0I8SA9qfu6m Dp9dbt0Fgqf3teHekKjV">
                                            <span style="color: rgb(6, 161, 229);">a</span>
                                            <p>anjana</p>
                                        </div>
                                        <div class="xRtz1YiatboiXGcx1PvQ">
                                            <span class="dJ169IoShf0lJLzpyUI6 false"></span>
                                            <span class="BntLK4UP1VRTGtmG_92B false"></span>
                                        </div>
                                        <div class="IwZOSgDXLFSgH8L1UBdn">
                                            <div class="nBWwl6VwTRoZfXN7bSSA">Pin</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        {/* <div class="teZiS1CRuvYhEaWuYfrg" style="display: none;">
                            <div>
                            </div>
                            <p>There's something wrong with your network. Trying to reconnect...</p>
                        </div>
                        <div class="RLMyCqREABaZ_zf3Wi3W" style="display: none;"><div>-1</div>
                        </div> */}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Chatpage;